import { useBreakpointValue } from "@chakra-ui/react"

export function useIsMobile() {
  return useBreakpointValue({ base: true, md: false }, { ssr: false }) ?? false
}

export function useIsTablet() {
  return (
    useBreakpointValue({ base: false, md: true, lg: false }, { ssr: false }) ??
    false
  )
}

export function useIsDesktop() {
  return useBreakpointValue({ base: false, lg: true }, { ssr: false }) ?? false
}
